<template>
  <header id="navbar" class="fixed w-full z-50 transition-all duration-300 bg-white backdrop-blur-sm">
    <nav class="container mx-auto px-6 py-4">
      <div class="flex justify-between items-center">
        <a href="#" class="text-2xl md:text-3xl font-display font-bold flex items-center">
          <a v-router-a href="/index#home">
            <img
              src="https://static.nemojoy.hk/images/icon/footer_logo_black.png"
              alt=""
              draggable="false"
              class="h-6 lg:h-12 lg:w-4/3"
            >
          </a>
        </a>

        <!-- 桌面导航 -->
        <div v-if="navShow" class="hidden md:flex items-center space-x-8">
          <a :href="'/index' + langType + '#home'" class="nav-item active text-dark-text hover:text-primary transition-colors">{{ $t('header-home') }}</a>
          <a :href="'/index' + langType + '#games'" class="nav-item text-dark-text hover:text-primary transition-colors">{{ $t('header-game') }}</a>
          <a v-if="newsShow" :href="'/index' + langType + '#news'" class="nav-item text-dark-text hover:text-primary transition-colors">{{ $t('header-new') }}</a>
          <a :href="'/index' + langType + '#contact'" class="nav-item text-dark-text hover:text-primary transition-colors">{{ $t('header-contact') }}</a>
          <el-dropdown v-if="langList.length > 1" trigger="click" class="nav-item text-dark-text hover:text-primary cursor-pointer" @command="switchToAny">
            <span class="el-dropdown-link">
              {{ $t('header-language') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="lang in langList" :key="lang" :command="lang">
                  {{ getLangName(lang) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

        <!-- 移动端菜单按钮 -->
        <button id="menu-toggle" class="md:hidden text-dark-text text-2xl focus:outline-none" @click="menuShow = !menuShow">
          <i class="fa fa-bars" />
        </button>
      </div>
    </nav>

    <!-- 移动端导航菜单 -->
    <div v-if="menuShow" id="mobile-menu" class="md:hidden bg-white border-t border-gray-100 z-50">
      <div class="container mx-auto px-4 py-4 flex flex-col space-y-4">
        <a :href="'/index' + langType" class="text-dark-text hover:text-primary py-2 transition-colors" @click.native="menuShow = false">{{ $t('header-home') }}</a>
        <a :href="'/index' + langType + '#games'" class="text-dark-text hover:text-primary py-2 transition-colors" @click.native="menuShow = false">{{ $t('header-game') }}</a>
        <a v-if="newsShow" :href="'/index' + langType + '#news'" class="text-dark-text hover:text-primary py-2 transition-colors" @click.native="menuShow = false">{{ $t('header-new') }}</a>
        <a :href="'/index' + langType + '#contact'" class="text-dark-text hover:text-primary py-2 transition-colors" @click.native="menuShow = false">{{ $t('header-contact') }}</a>
        <el-dropdown v-if="langList.length > 1" trigger="click" class="nav-item text-dark-text hover:text-primary cursor-pointer" @command="switchToAny">
          <span class="el-dropdown-link">
            {{ $t('header-language') }}
            <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="lang in langList" :key="lang" :command="lang">
                {{ getLangName(lang) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>
<script>
import { get_news_introduction_page } from '@/api/news'
import { mapState } from 'vuex'
import i18n from '@/i18n'
import store from '@/store'

export default {
  name: 'Header',
  data() {
    return {
      menuShow: false,
      navShow: true,
      newsShow: true
    }
  },
  computed: {
    ...mapState(['langList']),
    langType() {
      return this.$i18n.locale === 'en' ? '' : '?lang=' + this.$i18n.locale
    }
  },
  watch: {
    // 监听路由中 lang 参数的变化
    '$i18n.locale'() {
      this.$i18n.locale = i18n.locale
      this.checkNewsDiv()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkNewsDiv()
      this.getCurrentUrl() // 初始计算一次

      // 绑定滚动事件（保持原逻辑）
      window.addEventListener('scroll', this.getCurrentUrl)
    })
  },
  // 组件销毁时解绑事件，避免内存泄漏
  beforeDestroy() {
    window.removeEventListener('scroll', this.getCurrentUrl)
  },
  methods: {
    // langType对应语言名称
    getLangName(lang) {
      switch (lang) {
        case 'en':
          return 'English'
        case 'zh':
          return '中文'
        case 'zh-tw':
          return '繁體中文'
        case 'kr':
          return '한국어'
        case 'jp':
          return '日本語'
      }
    },

    checkNewsDiv() {
      const selectPage = {
        langType: this.$i18n.locale || 'en',
        pageNum: 1,
        pageSize: 3
      }
      get_news_introduction_page(selectPage).then(data => {
        this.newsShow = data.d.length > 0
      })
    },

    getCurrentUrl() {
      // 路径部分
      const routePath = window.location.pathname
      // 当前section部分
      let current = ''
      const sections = document.querySelectorAll('section')
      sections.forEach(section => {
        const sectionTop = section.offsetTop
        if (window.scrollY >= (sectionTop - 150)) {
          current = section.getAttribute('id') || ''
        }
      })

      // 这里可以根据需求处理 URL（如存储、展示等）
      const pathSection = routePath + current
      this.navShow = (pathSection !== '/index' && pathSection !== '/indexhome' && pathSection !== '/')
    },

    // 切换语言的函数
    switchLang(newLang) {
      // 获取当前 URL 的路径和哈希（如 /index#games）
      let currentPath = window.location.pathname // 路径：/index
      if (currentPath === '/index/newInfo') {
        currentPath = '/index/news'
      }
      const currentHash = window.location.hash // 哈希：#games（可能为空）
      const currentSearch = window.location.search // 现有参数：?其他参数

      // 2. 处理现有参数，替换或添加 lang 参数
      const urlParams = new URLSearchParams(currentSearch)
      const { langList } = store.state
      urlParams.set('lang', langList.includes(newLang) ? newLang : 'en') // 覆盖或添加 lang 参数
      const newSearch = urlParams.toString() ? `?${urlParams.toString()}` : ''

      // 构造新 URL：路径 + 新参数 + 哈希 强制跳转到新 URL（会刷新页面）
      window.location.href = `${currentPath}${newSearch}${currentHash}`

      // 获取当前路由信息
      // const currentHash = this.$route.hash

      // 更新查询参数中的语言
      // currentQuery.lang = newLang

      // 切换语言（不刷新页面）
      // this.$router.push({
      //   path: '/index',
      //   hash: currentHash,
      //   query: { lang: newLang }
      // })

      // 立即更新i18n locale，优化用户体验
      // this.$i18n.locale = newLang
    },

    // 选择切换语言
    switchToAny(command) {
      this.switchLang(command)
      this.menuShow = false
    }
  }
}
</script>
<style lang="scss">
@media screen and (min-width: 800px){
  .index_pc_head_logo{
    img{
      max-width: 9.8rem;
    }
  }
}

@media screen and (max-width: 800px){
  .index_pc_head_logo{
    height: 100%;
    img{
      height: 5.2rem;
    }
  }
}
</style>
